import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import './ContactUs.scss';

import commonConstant from '../../common/_commonConstant';
import { addClassBGBlack, removeClassBGBlack } from '../../common/_commonFunction';
import { TemplateCenter } from '../../components';

export default class ContactUs extends Component {
  componentDidMount() {
    addClassBGBlack();
  }

  componentWillUnmount() {
    removeClassBGBlack();
  }

  render() {
    return (
      <div className="ContactUs">
        <TemplateCenter>
          <div className="title">กรุณาติดต่อเจ้าหน้าที่เพื่อขอรหัสผ่านใหม่</div>
          <div className="phone">
            <span className="icon fas fa-phone-alt"/>
            <span>02-223-2222</span>
          </div>
          <Link id="btn-back" to={commonConstant.pathLogin} className="btn btn-primary btn-back">
            <span className="icon fas fa-arrow-left"/>
            <span>กลับหน้าหลัก</span>
          </Link>
        </TemplateCenter>
      </div>
    );
  }
}
